import request from "@/api/request";
import baseURL from "../index";
import * as apiCode from "../apiCode";
// import Qs from 'qs'

/// 获取秒杀时段
export function fetchDurations(data) {
  return request({
    url: baseURL + apiCode.getMiaoshaTimePeriods,
    data: data
  });
}
/// 获取秒杀商品列表
export function fetchGoods(data) {
  return request({
    url: baseURL + apiCode.getMiaoshaGoods,

    // 传params或用Qs.stringify转换后，可以以queryString形式发送
    // data则以payload形式发送
    // data: Qs.stringify(data),
    params: data 
  });
}
